import React from 'react';
import logo from '../ppa-logo-light.svg';
import styles from './LoadingSpinner.module.css';

interface LoadingSpinnerProps {
  label?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ label = 'Loading' }) => {
  return (
    <div className={styles.loadingContainer} role="status" aria-live="polite" aria-label={label}>
      <img className={styles.logo} src={logo} alt="" aria-hidden="true" />
      <div className={styles.label} aria-hidden="true">
        {label}<span className={styles.ellipsis} />
      </div>
    </div>
  );
};

export default LoadingSpinner;
